import { render, staticRenderFns } from "./DespesaSebraeForm.vue?vue&type=template&id=130d0060"
import script from "./DespesaSebraeForm.vue?vue&type=script&lang=js"
export * from "./DespesaSebraeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports